















































































































import {Component} from 'vue-property-decorator';
import GenericDistribution from '@/pages/Pages/Distributions/GenericDistribution.vue'
import ViberTemplate from '@/pages/Pages/Templates/ViberTemplate.vue'
import { MsgTransports } from '@/store/types';
import { SelectWings } from "wings-ui-components";

@Component({components: {GenericDistribution, ViberTemplate, SelectWings}})
export default class ViberDistribution extends GenericDistribution {

  transport = MsgTransports.VIBER

  beforeRouteLeave(to:any, from:any, next:any) {
    this.beforeLeave(to,from,next)
  }
}
